import axiosInstance from "@/lib/axios";
import { assignPreviewEndpoint } from "@/config/endpoints";
import { useQuery } from "@tanstack/react-query";
import type { AssignPreviewPayload } from "@/features/leads/types/assignPreview";

export type { AssignPreviewPayload } from "@/features/leads/types/assignPreview";

/**
 * Fetches assign-level preview for a lead + candidate user. Query is disabled by
 * default; call `refetch()` when the user confirms their pick in the drawer.
 */
export function useAssignPreview(
  leadId: number | null | undefined,
  userId: string | null | undefined,
  activeChildId: number | null | undefined,
) {
  return useQuery({
    queryKey: ["assign-preview", leadId, userId, activeChildId],
    queryFn: async () => {
      if (leadId == null || !userId) {
        throw new Error("assign-preview: missing lead or user");
      }
      const res = await axiosInstance.post<{
        status: string;
        preview: AssignPreviewPayload;
      }>(assignPreviewEndpoint(leadId), {
        userId: Number(userId),
        activeChildId: activeChildId ?? undefined,
      });
      return res.data.preview;
    },
    enabled: false,
  });
}

export async function fetchAssignPreview(
  leadId: number,
  userId: string | number,
  activeChildId?: number | null,
) {
  const res = await axiosInstance.post<{
    status: string;
    preview: AssignPreviewPayload;
  }>(assignPreviewEndpoint(leadId), {
    userId: Number(userId),
    activeChildId: activeChildId ?? undefined,
  });
  return res.data.preview;
}
